
import { DashboardPage } from "../../components/layout/dashboardPage";
import { Notifications } from "../../components/dashboard/notifications";
import { Col } from "../../style/base.style";
import { Colors } from "../../style/colors";
import { Invoices } from "../../components/dashboard/invoices";

export const DashboardInvoices:React.FC = () => {

  
    return (
      <DashboardPage title="invoices">
        <Col $width="100%" $justifyContent="flex-start" $alignItems="flex-start" $backgroundColor={Colors.whiteBackground} $padding="20px" $border={`1px solid ${Colors.fieldBorder}`} $borderRadius={10}>
         <Invoices/>
        </Col>
        
          
      </DashboardPage>
        
    )
}